// eslint-disable-next-line no-use-before-define
import React, { useEffect, useImperativeHandle, useRef } from 'react';
import { Pagination } from '@here/hds-pagination';
new Pagination(); // eslint-disable-line no-new
const HDSPagination = React.forwardRef((props, ref) => {
    const { className, onChange, pageInputType, page, itemsPerPage, itemsPerPageValues, totalItems, textBeforeItemsPerPage, textAfterItemsPerPage, textBeforePage, textAfterPage, textBeforeNav, textAfterNav, disabled, ...rest } = props;
    const innerRef = useRef(null);
    useImperativeHandle(ref, () => innerRef.current);
    const _handleChange = (e) => {
        if (e.target !== innerRef.current)
            return;
        onChange && onChange(e);
    };
    useEffect(() => {
        if (innerRef.current) {
            innerRef.current.addEventListener('change', _handleChange);
        }
        return () => {
            innerRef.current?.removeEventListener('change', _handleChange);
        };
    }, [onChange, innerRef]);
    return (React.createElement("hds-pagination", { ref: innerRef, ...(className && { class: className }), "page-input-type": pageInputType, page: page, "items-per-page": itemsPerPage, "total-items": totalItems || undefined, "items-per-page-values": itemsPerPageValues || undefined, "text-before-items-per-page": textBeforeItemsPerPage || undefined, "text-after-items-per-page": textAfterItemsPerPage || undefined, "text-before-page": textBeforePage || undefined, "text-after-page": textAfterPage || undefined, "text-before-nav": textBeforeNav || undefined, "text-after-nav": textAfterNav || undefined, ...(disabled && { disabled: true }), ...rest }));
});
HDSPagination.displayName = 'HDSPagination';
HDSPagination.defaultProps = {
    disabled: false,
    pageInputType: 'select',
    itemsPerPageValues: '',
    totalItems: undefined,
    textBeforeItemsPerPage: undefined,
    textAfterItemsPerPage: undefined,
    textBeforePage: undefined,
    textAfterPage: undefined,
    textBeforeNav: undefined,
    textAfterNav: undefined,
};
export default HDSPagination;
//# sourceMappingURL=HDSPagination.js.map